// @ts-nocheck
import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import { BreakpointValueProp } from "@store/Framework/Common/Utilities/breakpointValues";
import getBreakpointIndex from "@store/Framework/Common/Utilities/getBreakpointIndex";
import getFullBreakpointValues from "@store/Framework/Common/Utilities/getFullBreakpointValues";
import { StyledTheme } from "@toolkit/Framework/Types/StyledTheme";
import isArray from "lodash/isArray";

const getCurrentBreakpointValue = <T extends BreakpointValueProp<any>>(
    values: T,
    currentBreakpoint: BreakpointKey | undefined,
    theme: StyledTheme,
) => {
    if (!isArray(values)) {
        return values;
    }

    if (!currentBreakpoint) {
        return undefined;
    }

    return getFullBreakpointValues(values, theme.breakpoints.keys.length)?.[
        getBreakpointIndex(currentBreakpoint, theme)
    ];
};

export default getCurrentBreakpointValue;
